let $ = require('jquery');
let Vue = require('vue');
let Promise = require('bluebird');
let {url} = require('sci/utils');
let PhotoSwipe = require('photoswipe');
let PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');
let pswpElement = document.querySelector('.pswp');

Vue.directive('map-shadow', {
    priority: 1000,

    params: ['data'],

    bind: function () {
        $(this.el).click(() => {
            var items = [];

            let {latitude, longitude} = this.params.data;

            if (!latitude || !longitude) {
                return;
            }

            items.push({
                html: `<iframe src="${url("/utils/google-maps")}?latitude=${latitude}&longitude=${longitude}&title=imóvel" class="modal-frame"></iframe>`
            });

            var options = {
                // history & focus options are disabled on CodePen
                history: false,
                arrowKeys: true,
                closeOnScroll: false,
                shareEl: false,
                counterEl: false
            };

            var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

            gallery.init();

            return false;
        });
    },
    update: function (value) {
    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/map-shadow.js